import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";

export function useArtistGenres(): ReturnType<
	typeof trpc.artist.getGenres.useQuery
> {
	return trpc.artist.getGenres.useQuery(undefined, {
		...CACHE_TIERS.STATIC, // 5 minutes
	});
}
